import React from "react";
import Icon1 from "../../../../assets/images/trueCloud/1.svg";
import Icon2 from "../../../../assets/images/trueCloud/2.svg";
import Icon3 from "../../../../assets/images/trueCloud/3.svg";
import Icon4 from "../../../../assets/images/trueCloud/4.svg";
import Icon5 from "../../../../assets/images/trueCloud/5.svg";
import Icon6 from "../../../../assets/images/trueCloud/6.svg";
import Icon7 from "../../../../assets/images/trueCloud/7.svg";
import Icon8 from "../../../../assets/images/trueCloud/8.svg";
import Icon9 from "../../../../assets/images/trueCloud/9.svg";
import Icon10 from "../../../../assets/images/trueCloud/10.svg";
import Icon11 from "../../../../assets/images/trueCloud/11.svg";
import Icon12 from "../../../../assets/images/trueCloud/12.svg";
import Icon13 from "../../../../assets/images/trueCloud/13.svg";

const FeatureItem = ({ icon, title, wideIcon = false }) => (
  <div className="flex flex-col gap-1 items-start w-[150.662px] shrink-0">
    <div
      className={`flex items-center justify-start ${wideIcon ? "h-[34px] w-[95.2px]" : "w-[34px] h-[34px]"
        }`}
    >
      <img src={icon} alt={title} className="w-full h-full object-contain" />
    </div>
    <p className="text-[#5b5b5b] text-xs font-normal font-['Poppins'] leading-5">
      {title}
    </p>
  </div>
);

export const CloudFeaturesGrid = () => {
  const rowOne = [
    { icon: Icon1, title: "Cloud-based system management" },
    { icon: Icon2, title: "Automatic cloud database backup" },
    { icon: Icon4, title: "Centralized multi-site management" },
    { icon: Icon3, title: "Automatic updates" },
    { icon: Icon5, title: "Unlimited users, audit tracking" },
    { icon: Icon6, title: "Two Factor authentication" },
    { icon: Icon12, title: "Mobile App Management" },
  ];

  const rowTwo = [
    { icon: Icon8, title: "Push Notifications" },
    { icon: Icon9, title: "Unlimited scaling" },
    { icon: Icon11, title: "Enterprise-grade" },
    { icon: Icon13, title: "Mobile Credentials" },
    { icon: Icon10, title: "System Status" },
    { icon: Icon7, title: "Single Sign on", wideIcon: true },
  ];

  return (
    <section className="bg-white px-6 lg:px-[120px] py-[60px]">
      <div className="max-w-[1202px] mx-auto flex flex-col gap-6">
        <h2 className="text-[#171717] text-2xl font-medium font-['Inter'] text-center">
          Features
        </h2>

        <div className="flex flex-col gap-12 items-center justify-center">
          <div className="flex flex-wrap lg:flex-nowrap   items-center justify-center lg:justify-center gap-x-6 gap-y-8 w-full">
            {rowOne.map((feature) => (
              <FeatureItem
                key={feature.title}
                icon={feature.icon}
                title={feature.title}
              />
            ))}
          </div>

          <div className="flex flex-wrap lg:flex-nowrap justify-center lg:justify-center gap-x-6 gap-y-8 w-full ">
            {rowTwo.map((feature) => (
              <FeatureItem
                key={feature.title}
                icon={feature.icon}
                title={feature.title}
                wideIcon={feature.wideIcon}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
